// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:768px){.time_modal_box[data-v-577f09ba]{bottom:0}.form_bottom[data-v-577f09ba]{background:transparent;z-index:0}h2[data-v-577f09ba]{color:#fff}}@media (min-width:769px){.open_time2[data-v-577f09ba]{display:none}}.select-box-dropDown ul[data-v-577f09ba]{width:100%}", ""]);
// Exports
module.exports = exports;
